import React, { useRef } from 'react'
import { Box, Card, CardContent, CardHeader  } from "@mui/material"
import * as am5 from "@amcharts/amcharts5"
import * as am5xy from "@amcharts/amcharts5/xy"
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated"
import { useLayoutEffect } from "react"

const conversacionesPorDiaData = [
    { fecha: new Date(2023, 0, 1).getTime(), valor: 50 },
    { fecha: new Date(2023, 0, 2).getTime(), valor: 55 },
    { fecha: new Date(2023, 0, 3).getTime(), valor: 45 },
    { fecha: new Date(2023, 0, 4).getTime(), valor: 60 },
    { fecha: new Date(2023, 0, 5).getTime(), valor: 70 },
    { fecha: new Date(2023, 0, 6).getTime(), valor: 65 },
    { fecha: new Date(2023, 0, 7).getTime(), valor: 80 },
    { fecha: new Date(2023, 0, 8).getTime(), valor: 85 },
    { fecha: new Date(2023, 0, 9).getTime(), valor: 75 },
    { fecha: new Date(2023, 0, 10).getTime(), valor: 60 },
    { fecha: new Date(2023, 0, 11).getTime(), valor: 45 },
    { fecha: new Date(2023, 0, 12).getTime(), valor: 50 },
    { fecha: new Date(2023, 0, 13).getTime(), valor: 55 },
    { fecha: new Date(2023, 0, 14).getTime(), valor: 60 },
  ]

const ConversacionesPorDia = (ConversationData) => {
    const chartRef = useRef(null)


  
    useLayoutEffect(() => {
      if (!chartRef.current) return

      ConversationData.ConversationData.forEach((item) => { 
        //transform string to date
        const date = new Date(item.fecha);
        item.fecha = date.getTime();
      })
  
      // Crear instancia del gráfico
      const root = am5.Root.new(chartRef.current)
      root.setThemes([am5themes_Animated.new(root)])
  
      // Crear gráfico de línea
      const chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          panX: true,
          panY: true,
          wheelX: "panX",
          wheelY: "zoomX",
        }),
      )
  
      var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
      cursor.lineY.set("visible", false);

      // Crear ejes
      const xAxis = chart.xAxes.push(
        am5xy.DateAxis.new(root, {
          baseInterval: { timeUnit: "day", count: 1 },
          renderer: am5xy.AxisRendererX.new(root, {}),
          tooltip: am5.Tooltip.new(root, {}),
        }),
      )
  
      const yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          renderer: am5xy.AxisRendererY.new(root, {}),
        }),
      )
  
      // Crear serie
      const series = chart.series.push(
        am5xy.LineSeries.new(root, {
          name: "Conversaciones",
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: "valor",
          valueXField: "fecha",
          stroke: am5.color("#2196f3"),
          strokeWidth: 3,
          tooltip: am5.Tooltip.new(root, {
            labelText: "{valueY} Conversaciones ",
          }),
        }),
      )
  
      series.strokes.template.setAll({
        strokeWidth: 3,
      })
  
      // Añadir bullets
      series.bullets.push(() =>
        am5.Bullet.new(root, {
          sprite: am5.Circle.new(root, {
            radius: 5,
            fill: series.get("fill"),
            stroke: root.interfaceColors.get("background"),
            strokeWidth: 2,
          }),
        }),
      )
  
      series.data.setAll(ConversationData.ConversationData)
      series.appear(1000)
  
      // Hacer que el gráfico se ajuste a los datos
      chart.appear(1000, 100)
  
      return () => {
        root.dispose()
      }
    }, [ConversationData])
  
    return (
      <Card>
        <CardHeader title="Conversaciones por Día" />
        <CardContent>
          <Box ref={chartRef} style={{ width: "100%", height: 300 }} />
        </CardContent>
      </Card>
    )
  }

  export default ConversacionesPorDia;